module.exports = __webpack_public_path__ + "static/media/maestro_logo_mark_green.15225c9f.svg";